export default {
  'shared.password_required': 'Password Required',
  'shared.password_required_desc': 'This presentation is protected with a password',
  'shared.enter_password': 'Enter password',
  'shared.wrong_password': 'Incorrect password',
  'shared.link_expired': 'Link Expired',
  'shared.link_expired_desc': 'The validity period of this share link has passed',
  'shared.not_found': 'Page Not Found',
  'shared.not_found_desc': 'The share link is invalid or has been deleted',
  'shared.error': 'An Error Occurred',
  'shared.error_desc': 'Please try again later',
  'shared.loading_pdf': 'Loading PDF...',
};
